import {
  AvailabilityBlockSource,
  BookingStatus,
} from '@avantstay/arriere-clients/dist/arriereBackoffice'

/** A reservation still occrenameupies the home in these statuses; cancelled, declined, no-show and quoted ones do not. */
export const VALID_BOOKING_STATUSES = [
  BookingStatus.booked,
  BookingStatus.checkedIn,
  BookingStatus.checkedOut,
  BookingStatus.requested,
  BookingStatus.modified,
]

/** Early check-in / late check-out blocks extend a stay by hours, not nights. */
const ECI_LCO_BLOCK_SOURCES = [
  AvailabilityBlockSource.eciLco,
  AvailabilityBlockSource.earlyCheckIn,
  AvailabilityBlockSource.lateCheckOut,
]

export const noEciLco = ({ source }: { source: AvailabilityBlockSource }) =>
  !ECI_LCO_BLOCK_SOURCES.includes(source)
